module.exports = __webpack_public_path__ + "img/good.b9da765d.png";